import { axiosInstance } from './api'

import { DashboardData, WalletDashboard, ActivityDashboard, TransactionsDashboard } from 'types/advertiser-dashboard'

export const advertiserDashboardApi = {
  getEdgepoints(id: number, filterBy: string) {
    return axiosInstance.get<{ from: string; to: string }>(
      `advertiser/edge-points/${filterBy}s${id > 0 ? '/' + id : ''}`
    )
  },
  getChart(id: number, params: { interval: { from: string; to: string }; filterBy: string }) {
    return axiosInstance.post<DashboardData>(`advertiser/dashboard/${params.filterBy}s${id > 0 ? '/' + id : ''}`, {
      from_dt: params.interval.from,
      to_dt: params.interval.to,
    })
  },
  getUserActivityChart(id: number, params: { interval: { from: string; to: string }; filterBy: string }) {
    return axiosInstance.post<ActivityDashboard>(
      `advertiser/dashboard/user-activity/${params.filterBy}s${id > 0 ? '/' + id : ''}`,
      { from_dt: params.interval.from, to_dt: params.interval.to }
    )
  },
  getWalletChart(id: number, params: { interval: { from: string; to: string }; filterBy: string }) {
    return axiosInstance.post<WalletDashboard>(
      `advertiser/dashboard/wallets/${params.filterBy}s${id > 0 ? '/' + id : ''}`,
      { from_dt: params.interval.from, to_dt: params.interval.to }
    )
  },
  getTransactionsChart(id: number, params: { interval: { from: string; to: string }; filterBy: string }) {
    return axiosInstance.post<TransactionsDashboard>(
      `advertiser/dashboard/transactions/${params.filterBy}s${id > 0 ? '/' + id : ''}`,
      { from_dt: params.interval.from, to_dt: params.interval.to }
    )
  },
  downloadReport(id: number, filterBy: string) {
    return axiosInstance.get(`advertiser/report/${filterBy}s${id !== -1 ? '/' + id : ''}`, {
      responseType: 'blob',
    })
  },
  downloadActivityReport(id: number, filterBy: string) {
    return axiosInstance.get(`advertiser/report/user-activity/${filterBy}s${id !== -1 ? '/' + id : ''}`, {
      responseType: 'blob',
    })
  },
}
